// src/Components/Includes/GeradorQrCode.js
import React, { useState, useEffect } from "react";
import ControlOptions from "./Generator/Options/ControlOptions";
import ControlIcons from "./Generator/Options/Icons/ControlIcons";
import UrlQrCode from "./Generator/Types/UrlQrCode";
import TextQrCode from "./Generator/Types/TextQrCode";
import EmailQrCode from "./Generator/Types/EmailQrCode";
import TelQrCode from "./Generator/Types/TelQrCode";
import VCardQrCode from "./Generator/Types/VCardQrCode";
import WifiQrCode from "./Generator/Types/WifiQrCode";
import PixQrCode from "./Generator/Types/PixQrCode";
import DownloadButtons from "./Generator/Download/DownloadButtons";
import useQRCodeGenerator from "../../hooks/useQRCodeGenerator";

const GeradorQrCode = ({ toggleModal }) => {
    const [qrType, setQrType] = useState("url");
    const [qrData, setQrData] = useState("");
    const [qrOptions, setQrOptions] = useState({
        color: "#000000",
        bgColor: "#ffffff",
        dotsType: "square",
        image: null,
        colorMode: "simple",
        gradientType: "linear",
        gradientColors: ["#000000", "#1845af"]
    });
    const [qrCodeInstance, setQrCodeInstance] = useState(null);
    const qrCodeRef = useQRCodeGenerator(qrData, qrType, qrOptions);

    useEffect(() => {
        if (qrCodeRef.current) {
            setQrCodeInstance(qrCodeRef.current);
        }
    }, [qrCodeRef]);

    useEffect(() => {
        switch (qrType) {
            case "url":
                setQrData("https://qrcbr.com.br");
                break;
            case "text":
                setQrData("Digite seu texto");
                break;
            case "email":
                setQrData("contato@qrcbr.com.br");
                break;
            case "tel":
                setQrData("tel:+55 11 91234-5678");
                break;
            case "vcard":
                setQrData("BEGIN:VCARD\nVERSION:3.0\nFN:Maria Silva\nORG:Empresa XYZ\nTITLE:Gerente de Vendas\nEMAIL:maria.silva@exemplo.com\nTEL:+55 11 91234-5678\nADR:Rua Exemplo, 123\nURL:https://exemplo.com\nBDAY:1990-01-01\nEND:VCARD");
                break;
            case "wifi":
                setQrData("WIFI:T:WPA;S:Minha Rede Wi-Fi;P:minhaSenha123;;");
                break;
            case "pix":
                setQrData("");
                break;
            default:
                setQrData("");
                break;
        }
    }, [qrType]);

    const renderQrCodeFields = () => {
        switch (qrType) {
            case "url":
                return <UrlQrCode setQrData={setQrData} />;
            case "text":
                return <TextQrCode setQrData={setQrData} />;
            case "email":
                return <EmailQrCode setQrData={setQrData} />;
            case "tel":
                return <TelQrCode setQrData={setQrData} />;
            case "vcard":
                return <VCardQrCode setQrData={setQrData} />;
            case "wifi":
                return <WifiQrCode setQrData={setQrData} />;
            case "pix":
                return <PixQrCode setQrData={setQrData} />;
            default:
                return null;
        }
    };

    return (
        <div className="container">
            <div className="page-title text-shadow">Gerador de QR Code Online Gratuito</div>
            <div className="qr-generator">
                <div className="controls">
                    <div className="form-group">
                        <label htmlFor="qr-type">Tipo de QR Code</label>
                        <select id="qr-type" value={qrType} onChange={(e) => setQrType(e.target.value)}>
                            <option value="url">URL</option>
                            <option value="text">Texto</option>
                            <option value="email">E-mail</option>
                            <option value="tel">Telefone</option>
                            <option value="vcard">VCard</option>
                            <option value="wifi">Wi-Fi</option>
                            <option value="pix">Pix</option>
                        </select>
                    </div>
                    {renderQrCodeFields()}
                    <ControlOptions setQrOptions={setQrOptions} qrOptions={qrOptions} />
                    <ControlIcons setQrOptions={setQrOptions} toggleModal={toggleModal} />
                </div>
                <div className="preview">
                    <div ref={qrCodeRef}></div>
                    <DownloadButtons qrCode={qrCodeInstance} toggleModal={toggleModal} data={qrData} options={qrOptions} type={qrType} setQrData={setQrData} />
                </div>
            </div>
        </div>
    );
};

export default GeradorQrCode;